import { Repository } from "./adapters/repository";

import * as editProjectReportTemplate from "./useCases/editProjectReportTemplate";
import * as retrieveProjectReportTemplate from "./useCases/retrieveProjectReportTemplate";
import * as submitProjectReport from "./useCases/submitProjectReport";
import * as retrieveProjectReports from "./useCases/retrieveProjectReports";
import * as retrieveProjectReport from "./useCases/retrieveProjectReport";
import * as removeProjectReport from "./useCases/removeProjectReport";
import * as editProjectReport from "./useCases/editProjectReport";

enum UseCases {
  editProjectReportTemplate = "editProjectReportTemplate",
  retrieveProjectReportTemplate = "retrieveProjectReportTemplate",
  submitProjectReport = "submitProjectReport",
  retrieveProjectReports = "retrieveProjectReports",
  retrieveProjectReport = "retrieveProjectReport",
  removeProjectReport = "removeProjectReport",
  editProjectReport = "editProjectReport",
}

interface Core {
  [UseCases.editProjectReportTemplate]: editProjectReportTemplate.Interactor;
  [UseCases.retrieveProjectReportTemplate]: retrieveProjectReportTemplate.Interactor;
  [UseCases.submitProjectReport]: submitProjectReport.Interactor;
  [UseCases.retrieveProjectReports]: retrieveProjectReports.Interactor;
  [UseCases.retrieveProjectReport]: retrieveProjectReport.Interactor;
  [UseCases.removeProjectReport]: removeProjectReport.Interactor;
  [UseCases.editProjectReport]: editProjectReport.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.editProjectReportTemplate]:
      editProjectReportTemplate.createInteractor(dependencies.repository),
    [UseCases.retrieveProjectReportTemplate]:
      retrieveProjectReportTemplate.createInteractor(dependencies.repository),
    [UseCases.submitProjectReport]: submitProjectReport.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveProjectReports]: retrieveProjectReports.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveProjectReport]: retrieveProjectReport.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeProjectReport]: removeProjectReport.createInteractor(
      dependencies.repository,
    ),
    [UseCases.editProjectReport]: editProjectReport.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
